(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qt-hero-frame"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Hydrate les diapositives differees. Voir snippets/qt-hero-slide-img.liquid :
     seule la premiere photo porte un `src`, pour que les deux autres ne se
     disputent pas la bande passante avec l'affichage initial. Elles sont
     chargees une fois la page complete, soit plusieurs secondes avant la
     premiere transition. */
  function hydrate(root) {
    var imgs = root.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.dataset.srcset) im.setAttribute('srcset', im.dataset.srcset);
      if (im.dataset.src) im.setAttribute('src', im.dataset.src);
      im.removeAttribute('data-srcset');
      im.removeAttribute('data-src');
    }
  }

  function init(root) {
    if (root.dataset.qthfInit) return;
    root.dataset.qthfInit = '1';

    if (document.readyState === 'complete') {
      hydrate(root);
    } else {
      window.addEventListener('load', function () { hydrate(root); }, { once: true });
    }

    var sws = root.querySelectorAll('[data-qthf-sw]');
    var nameEl = root.querySelector('[data-qthf-name]');
    var priceEl = root.querySelector('[data-qthf-price]');
    var countEl = root.querySelector('[data-qthf-count]');
    var progEl = root.querySelector('[data-qthf-prog]');
    var lineEl = root.querySelector('[data-qthf-line]');
    var cta = root.querySelector('[data-qthf-cta]');

    function select(i) {
      var b = sws[i];
      if (!b) return;
      var pct = ((i + 1) / sws.length) * 100;
      root.style.setProperty('--qthf-accent', b.dataset.accent);
      for (var j = 0; j < sws.length; j++) {
        sws[j].classList.toggle('is-on', j === i);
        sws[j].setAttribute('aria-pressed', j === i ? 'true' : 'false');
      }
      if (nameEl) {
        nameEl.style.opacity = 0;
        setTimeout(function () { nameEl.textContent = b.dataset.name; nameEl.style.opacity = 1; }, 170);
      }
      if (priceEl) priceEl.textContent = b.dataset.price || '';
      if (countEl) countEl.textContent = ('0' + (i + 1)).slice(-2);
      if (progEl) progEl.style.width = pct + '%';
      if (lineEl) lineEl.style.background =
        'linear-gradient(90deg,' + b.dataset.accent + ' 0%,' + b.dataset.accent + ' ' + pct + '%,transparent ' + pct + '%)';
      /* Le CTA suit le coloris : sans ca le bouton renvoie sur la collection
         alors que le visiteur a deja choisi une couleur. */
      if (cta && b.dataset.url) cta.setAttribute('href', b.dataset.url);
    }

    for (var k = 0; k < sws.length; k++) {
      (function (idx) { sws[idx].addEventListener('click', function () { select(idx); }); })(k);
    }
    if (sws.length) select(0);

    var par = root.querySelector('[data-qthf-par]');
    var frame = root.querySelector('.qthf-frame');
    if (par && frame && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
      /* Pose ici et pas dans la feuille : en CSS statique, la couche composite
         existe aussi sur iOS, ou elle echappe au clip arrondi du cadre. */
      par.style.willChange = 'transform';
      frame.addEventListener('pointermove', function (e) {
        var r = frame.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        par.style.transform = 'translate3d(' + (-x * 18) + 'px,' + (-y * 14) + 'px,0)';
      });
      frame.addEventListener('pointerleave', function () { par.style.transform = 'translate3d(0,0,0)'; });
    }
  }

  function boot() { document.querySelectorAll('[data-qthf-frame]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  /* L'editeur de theme remonte la section sans recharger la page. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-qthf-frame]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
